// ABOUTME: Builds what the overview registry and drill-down tables read from one attempt: its result
// ABOUTME: as `data`, its file, and its warning/error log lines as the `logs` lists.

import { JobAttempt, JobLogEntry, JobResultView, Jobs } from '../../../types';

/** The attempt whose file the attachment endpoint serves: the latest one that produced a file. */
export const attachmentAttemptOf = (attempts: JobAttempt[]): number | undefined =>
    attempts
        .filter(attempt => !!attempt.filename)
        .reduce<number | undefined>(
            (latest, attempt) => Math.max(latest ?? 0, attempt.n),
            undefined,
        );

export const toResultView = (
    job: Jobs,
    attempt: JobAttempt | undefined,
    issues: JobLogEntry[],
): JobResultView =>
    ({
        id: job.id,
        type: job.type,
        data: (attempt ? attempt.result : job.result) ?? undefined,
        logs: {
            infos: [],
            warnings: issues.filter(entry => entry.level === 'warn').map(entry => entry.message),
            errors: issues.filter(entry => entry.level === 'error').map(entry => entry.message),
        },
        filename: attempt ? attempt.filename : job.filename,
        ...(attempt && attempt.n === attachmentAttemptOf(job.attempts ?? [])
            ? { attachmentJobId: job.id }
            : {}),
        // The registry narrows on the type: any type string is accepted, the unknown ones simply
        // fall back to the generic presentation.
    } as JobResultView);
